import handleError from 'utils/handleError';
import Notification from 'utils/notifications';
import { toast } from 'react-toastify';

import { 
  getFaqs,
  postFaq,
  putFaq,
  deleteFaq,
} from 'utils/web-api';

import {
  FaqActionTypes,
  setFaqList,
  setFaqLoadingList,
  setFaqLoadingDelete,
  setFaqLoadingSave,
  setFaqListParams,
} from 'store/reducers/faq.reducer';

const { all, call, put, select, debounce, takeEvery } = require('redux-saga/effects');

function* asyncList({ payload }) {
  const { page = 0, pageSize = 10} = payload || {};
  try {
    yield put(setFaqLoadingList(true));
    const token = yield select((state) => state.Auth.token);

    const response = yield call(() => getFaqs(token, page, pageSize));

    yield put(setFaqList(response));
    yield put(setFaqListParams({ page, pageSize }));
  } catch (error) {
    handleError(error);
    Notification('error', 'Erro ao carregar tópicos.');
  } finally {
    yield put(setFaqLoadingList(false));
  }
}

function* asyncCreate({ payload }) {
  const { data, onClose } = payload || {};
  try {
    yield put(setFaqLoadingSave(true));
    const token = yield select((state) => state.Auth.token);

    yield call(() => postFaq(data, token));
    toast.success('Tópico criado com sucesso!');

    const { listParams } = yield select((state) => state.Faq);
    yield call(() => asyncList({ payload: listParams }));

    if (onClose) yield call(onClose);
  } catch (error) {
    if (error?.response?.status !== 401) {
      Notification('error', `${error?.response?.data?.detail || 'Erro ao criar tópico.'}`);
    } else {
      handleError(error);
    }
  } finally {
    yield put(setFaqLoadingSave(false));
  }
}

function* asyncUpdate({ payload }) {
  const { id, data, onClose } = payload || {};
  try {
    yield put(setFaqLoadingSave(true));
    const token = yield select((state) => state.Auth.token);

    yield call(() => putFaq(id, data, token));
    toast.success('Tópico atualizado com sucesso!');

    const { listParams } = yield select((state) => state.Faq);
    yield call(() => asyncList({ payload: listParams }));

    if (onClose) yield call(onClose);
  } catch (error) {
    if (error?.response?.status !== 401) {
      Notification('error', `${error?.response?.data?.detail || 'Erro ao atualizar tópico.'}`);
    } else {
      handleError(error);
    }
  } finally {
    yield put(setFaqLoadingSave(false));
  }
}

function* asyncDelete({ payload }) {
  const { id, onClose } = payload || {};
  try {
    yield put(setFaqLoadingDelete(true));
    const token = yield select((state) => state.Auth.token);

    yield call(() => deleteFaq(id, token));
    Notification('success', 'Tópico removido com sucesso!');

    const { listParams } = yield select((state) => state.Faq);
    yield call(() => asyncList({ payload: listParams }));

    if (onClose) yield call(onClose);
  } catch (error) {
    if (error?.response?.status !== 401) {
      Notification('error', `${error?.response?.data?.detail || 'Erro ao remover tópico.'}`);
    } else {
      handleError(error);
    }
  } finally {
    yield put(setFaqLoadingDelete(false));
  }
}

export default function* FaqSaga() {
  yield all([

    yield debounce(500, FaqActionTypes.ASYNC_LIST, asyncList),

    yield takeEvery(FaqActionTypes.ASYNC_CREATE, asyncCreate),
    yield takeEvery(FaqActionTypes.ASYNC_UPDATE, asyncUpdate),
    yield takeEvery(FaqActionTypes.ASYNC_DELETE, asyncDelete),
  ]);
}
